export const setbar = (value) => {
	return { type: "SET_BAR", payload: value };
};

export const setpie = (value) => {
	return { type: "SET_PIE", payload: value };
};

export const setstack = (value) => {
	return { type: "SET_STACKBAR", payload: value };
};

export const setline = (value) => {
	return { type: "SET_LINE", payload: value };
};

export const setarea = (value) => {
	return { type: "SET_AREA", payload: value };
};

export const setheat = (value) => {
	return { type: "SET_HEAT", payload: value };
};

export const setwordcloud = (value) => {
	return { type: "SET_WORDCLOUD", payload: value };
};

export const setsunbusrt = (value) => {
	return { type: "SET_SUNBURST", payload: value };
};

export const setgeo = (value) => {
	return { type: "SET_GEO", payload: value };
};

export const setvenn = (value) => {
	return { type: "SET_VENN", payload: value };
};

export const setdensity = (value) => {
	return { type: "SET_DENSITY", payload: value };
};

export const setwordcloudType = (value) => {
	return { type: "SET_WORDCLOUDTYPE", payload: value };
};

export const setbubble = (value) => {
	return { type: "SET_BUBBLE", payload: value };
};

export const setMapPie = (value) => {
	return { type: "SET_MAP_PIE", payload: value };
};

export const setBarConversion = (value) => {
	return { type: "SET_BAR_CONVERSION", payload: value };
};

export const setclearAll = (value) => {
	return async (dispatch) => {
		value !== "bar" && dispatch(setbar(null));
		value !== "line" && dispatch(setline(null));
		value !== "pie" && dispatch(setpie(null));
		value !== "heat" && dispatch(setheat(null));
		value !== "area" && dispatch(setarea(null));
		value !== "venn" && dispatch(setvenn(null));
		value !== "sunburst" && dispatch(setsunbusrt(null));
		value !== "wordcloud" && dispatch(setwordcloud(null));
		value !== "stack" && dispatch(setstack(null));
		value !== "geo" && dispatch(setgeo(null));
		value !== "density" && dispatch(setdensity(null));
		value !== "bubble" && dispatch(setbubble(null));

		value !== "map_pie" && dispatch(setMapPie(null));
	};
};
